import "core-js/es6/promise";
import "core-js/es6/array";
import "core-js/es6/string";

import { app } from "@/app";

app.$mount("#app");
